class window.ImageResizer
  constructor: ->
    @initImageResizer()

  initImageResizer: ->
    self = this
    $('.js-scaling-image').each(
      ->
        self.checkImageHeight(this)

        element = this

        $(window).resize ->
          self.checkImageHeight(element)
    )

  checkImageHeight: (self)->
    newHeight = $(self).width()*0.625

    if (newHeight <= 230)
      $(self).css('height','230px')
    else if (newHeight >= 480)
      $(self).css('height','480px')
    else
      $(self).css('height',parseInt(newHeight)+'px')



// WEBPACK FOOTER //
// ./assets/javascripts/app/image_resizer.coffee